export const CLEAR_PORTAL_VERSIONS_STATE = 'CLEAR_PORTAL_VERSIONS_STATE';

export const GET_PORTAL_VERSIONS_LIST_START = 'GET_PORTAL_VERSIONS_LIST_START';
export const GET_PORTAL_VERSIONS_LIST_SUCCESS = 'GET_PORTAL_VERSIONS_LIST_SUCCESS';
export const GET_PORTAL_VERSIONS_LIST_FAIL = 'GET_PORTAL_VERSIONS_LIST_FAIL';